import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ParameterFormatter from '../ParameterFormatter';

const Number2Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.min} /></th>
                    <td><ParameterFormatter value={question.min} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.max} /></th>
                    <td><ParameterFormatter value={question.max} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.step} /></th>
                    <td><ParameterFormatter value={question.step} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.interval} /></th>
                    <td><ParameterFormatter value={question.interval} /></td>
                </tr>
            </tbody>
        </table>
    </>
);

Number2Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default Number2Type;
